import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "När träder gårdsförsäljningen i kraft?";
const SHORT_ANSWER = "Reglerna träder i kraft 1 juni 2026 i samband med övriga förändringar i alkohollagen.";

export const Route = createFileRoute("/fraga/nar-trader-gardsforsaljning-i-kraft")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "När träder gårdsförsäljningen i kraft" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Tillstånd kan sökas i förväg så att produktionen kan starta i tid. Folkhälsomyndigheten och kommunerna förbereder ansökningsblanketter och föreskrifter."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning/regler-2026", label: "Gårdsförsäljning – när och hur" }}
      related={[{"to": "/fraga/vad-ar-skillnaden-mot-systembolaget", "label": "Vad skiljer gårdsförsäljning från Systembolaget?"}, {"to": "/fraga/vad-ar-serveringstillstand", "label": "Vad är ett serveringstillstånd?"}, {"to": "/fraga/vilka-volymregler-galler-for-mikrobryggeri", "label": "Vilka volymregler gäller för mikrobryggeri vid gårdsförsäljning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "När träder gårdsförsäljningen i kraft?" },
      { name: "description", content: "Reglerna träder i kraft 1 juni 2026 i samband med övriga förändringar i alkohollagen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/nar-trader-gardsforsaljning-i-kraft" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/nar-trader-gardsforsaljning-i-kraft" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/nar-trader-gardsforsaljning-i-kraft",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "När träder gårdsförsäljningen i kraft", url: "https://alkoholprovet.se/fraga/nar-trader-gardsforsaljning-i-kraft" },
      ]),
    ],
  }),
});
